import { create, all } from 'mathjs'

const MathJs = {}

export default MathJs.install = function (Vue, options) {
	Vue.prototype.$math = function () {
		return create(all, {})
	}()
}
